import { Injectable, inject, signal } from '@angular/core';
import { Observable, of } from 'rxjs';
import { map, tap } from 'rxjs/operators';
import { GetAiEntitlementUseCase } from '../use-cases/get-ai-entitlement/get-ai-entitlement.use-case';

/**
 * Singleton state for AI entitlement.
 * Caches the AI entitlement flag and exposes it as a readonly signal.
 * Use loadOnce() to fetch from the API (no-op if already loaded).
 */
@Injectable({ providedIn: 'root' })
export class AiEntitlementState {
  private readonly _getUseCase = inject(GetAiEntitlementUseCase);

  private readonly _loaded = signal(false);
  private readonly _aiEntitlementEnabled = signal(false);

  public readonly aiEntitlementEnabled = this._aiEntitlementEnabled.asReadonly();

  public loadOnce(): Observable<void> {
    if (this._loaded()) {
      return of(undefined);
    }
    return this._getUseCase.execute().pipe(
      tap((result) => {
        if (result.success && result.data) {
          this._aiEntitlementEnabled.set(result.data.aiEntitlementEnabled ?? false);
        }
        this._loaded.set(true);
      }),
      map(() => undefined),
    );
  }

  public update(enabled: boolean): void {
    this._aiEntitlementEnabled.set(enabled);
    this._loaded.set(true);
  }
}
